import React, { FC } from "react";
import { StepFourParams } from "../../../Pages/MyAppointment/Steps/StepFourParams.csharp";
import { Button } from '../../Booking/Button/Button';

interface StepFourProps extends StepFourParams {
  onClose: () => void;
}

export const ExitStep: FC<StepFourProps> = ({ onClose, title, content }) => {
  return (
    <>
      <h2>{title}</h2>
      <div dangerouslySetInnerHTML={{ __html: content }} />
      <Button fullWidth={true} size='large' onClick={onClose}>
        Steng vindu
      </Button>
    </>
  );
};
